import shallow from 'zustand/shallow'
import useStore from '../store/useStore'

export default (docId: string) => {
  return useStore(state => state.config?.[docId] || {}, shallow)
}
